import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchProcessedAdsByClusterProps = {
  period1StartDate: Moment;
  period1EndDate: Moment;
  period2StartDate: Moment;
  period2EndDate: Moment;
  clusters?: Array<string>;
  partners?: Array<number>;
  origami?: string;
};
export type FetchProcessedAdsByCluster = (dates: FetchProcessedAdsByClusterProps) => void;

const fetchProcessedAdsByCluster = ({
  period1StartDate,
  period1EndDate,
  period2StartDate,
  period2EndDate,
  clusters = [],
  partners = [],
  origami,
}: FetchProcessedAdsByClusterProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    period_1_start_date: period1StartDate.format("YYYY-MM-DD"),
    period_1_end_date: period1EndDate.format("YYYY-MM-DD"),
    period_2_start_date: period2StartDate.format("YYYY-MM-DD"),
    period_2_end_date: period2EndDate.format("YYYY-MM-DD"),
    cluster: clusters.length ? "'" + clusters.join("','") + "'" : null,
    partner: partners.join(","),
    enable_origami: origami,
  };
  await fetchReport("processed_ads_by_cluster", dispatch, params);
};

export default fetchProcessedAdsByCluster;
